<template>
  <div class="grouped-text-fields">
    <div v-if="invalidParameterError">
      <p class="error-message">{{invalidParameterError}}</p>
      <p class="monospace">proportions: {{proportions}}</p>
      <p class="monospace">placeholders: {{placeholders}}</p>
      <p class="monospace">identifiers: {{identifiers}}</p>
      <p class="monospace">characterLimits: {{characterLimits}}</p>
    </div>

    <div v-else>
      <div class="container">
        <div
          v-for="(t, i) in textFields"
          class="text-field"
          :style="{flex: t.proportion}"
          :key="i"
        >
          <div class="cf-form-field">
            <input
              type="text"
              v-model="t.value"
              class="cf-form-input"
              :placeholder="t.placeholder"
              :maxlength="t.characterLimit"
              @blur="saveValuesToContentful()"
              @input="saveValuesToContentfulWithThrottle()"
            >
            <div class="cf-form-hint">
              {{t.value.length}} / {{t.characterLimit}}
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import throttle from 'lodash.throttle';

const INSTALLATION_PARAM_DELIMITER = ',';
const THROTTLE_DURATION_MS = 1000;

export default {
  name: 'GroupedTextFields',
  data() {
    return {
      // Happy case
      textFields: [],
      // Error case
      invalidParameterError: null,
      proportions: '',
      placeholders: '',
      identifiers: '',
      characterLimits: '',
    };
  },
  created() {
    const ex = this.$extension;
    const params = ex.parameters.instance;

    // Retrieve instance parameters
    const proportions = params.proportions.split(INSTALLATION_PARAM_DELIMITER);
    const placeholders = params.placeholders.split(INSTALLATION_PARAM_DELIMITER);
    const identifiers = params.identifiers.split(INSTALLATION_PARAM_DELIMITER);
    const characterLimits = params.characterLimits.split(INSTALLATION_PARAM_DELIMITER);

    // Check if all param lengths are equal
    const isEqual = [
      proportions.length, placeholders.length, identifiers.length, characterLimits.length
    ].every((v, i, arr) => v === arr[0]);

    if (isEqual) {
      // Retrieve values
      const value = ex.field.getValue();
      const valueList = (value) ? value.values : [];

      for (let i in proportions) {
        this.textFields.push({
          value: (i < valueList.length) ? valueList[i] : '',
          proportion: proportions[i],
          placeholder: placeholders[i],
          identifier: identifiers[i],
          characterLimit: characterLimits[i],
        });
      }
    } else {
      this.invalidParameterError = `Number of fields specified by instance parameters does not match. Please check again.`;
      this.proportions = params.proportions;
      this.placeholders = params.placeholders;
      this.identifiers = params.identifiers;
      this.characterLimits = params.characterLimits;
    }
  },
  mounted() {
    // To make sure there are values when an entry is initially created
    this.saveValuesToContentful();
  },
  methods: {
    saveValuesToContentful() {
      const objectToSave = {
        // Save all values to `values` field as array
        values: this.textFields.map(t => t.value),
      };
      // Also expose each value under the keys defined by identifiers
      // The code doesn't verify the uniqueness of identifiers
      for (const tf of this.textFields) {
        objectToSave[tf.identifier] = tf.value;
      }

      console.log('====== $extension.field.setValue() =======');
      this.$extension.field.setValue(objectToSave).then((data) => {
        console.log('Successfully set CF field', data);
      }).catch((error) => {
        console.log('error during saving field', error);
      });
    },
    saveValuesToContentfulWithThrottle: throttle(function() {
      this.saveValuesToContentful();
    }, THROTTLE_DURATION_MS),
  },
};
</script>

<style scoped lang="scss">
  .grouped-text-fields {
    padding: 2px 2px 0;
    min-height: 62px;

    .container {
      display: flex;
    }

    .text-field {
      margin-right: 16px;
    }

    .text-field:last-child {
      margin-right: 0;
    }

    .monospace {
      font-family: monospace;
      line-height: 0.4em;
    }

    .error-message {
      color: #f05751;
    }

    ::placeholder {
      color: #b5c2d2;
    }

    .cf-form-hint {
      color: #2d2f31;
      text-align: right;
      padding-right: 2px;
      font-size: 12.6px;
    }

    .cf-form-field {
      margin-bottom: 0;
    }
  }
</style>
